import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        userIds: '=',
        showNavigationError: '=',
        showAddButton: '=',
        enableAll: '=',
        isInfiniteDeadline: '<',
        customOptions: '='
    },
    template: `
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <div class="well">
            <pagination-tools list="vm.list" enable-all="vm.enableAll" custom-options="vm.customOptions"></pagination-tools>
            <table class="data01"
                ng-if="!vm.list.loading && vm.list.items.length"
                datatable dt-options="vm.DATATABLES"
                ng-init="vm.initBulk()">
                <thead>
                    <tr>
                        <th><input ng-model="vm.checked" ng-click="vm.toggleAll()" type="checkbox"></th>
                        <th>{{ 'planning.Name' | translate }}</th>
                        <th>{{ 'planning.Position' | translate }}</th>
                        <th>{{ 'planning.Previous date completed' | translate }}</th>
                        <th>{{ 'planning.Personal deadline' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td><input
                            type="checkbox"
                            ng-if="vm.showCheckbox(item)"
                            ng-checked="vm.hasUserId(item.id)"
                            ng-click="$event.stopPropagation();vm.toggleUserId(item.id)"
                        ></td>
                        <td>
                            {{ item.displayName }}
                            <span
                              ng-if="vm.hasCourseApg(item)"
                              ng-class="{
                                   'badge-negative': vm.hasStartedApg(item),
                                   'badge-warn': !vm.hasStartedApg(item)
                               }"
                              class="badge round"
                              tooltip-placement="right"
                              uib-tooltip="{{
                               vm.hasStartedApg(item)
                                ? vm.startedPlanningGroupMessage
                                : vm.planningGroupMessage
                               }}"
                           >
                                A
                            </span>
                        </td>
                        <td>
                            <drl-partial-table drls="item.drlsWithValue"></drl-partial-table>
                        </td>
                        <td>
                            {{ (item.courseUsers.length && item.courseUsers[0].previousPassedTime) ? vm.MomentService.formatTimeStamp(item.courseUsers[0].previousPassedTime, 'DD.MM.YYYY') : '-' }}
                        </td>
                        <td ng-bind-html="item.courseUsers[0].deadline | personalDeadline: item.courseUsers[0].previousPassedTime:vm.isInfiniteDeadline"></td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, MomentService, DATATABLES,
        AUTOMATED_PLANNING_GROUP_STATUS_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.MomentService = MomentService;
        this.DATATABLES = DATATABLES;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
    }

    $onInit () {
        this.startedPlanningGroupMessage = this.$translate.instant('planning.Added to started automated planning group');
        this.planningGroupMessage = this.$translate.instant('planning.Added to automated planning group');
    }

    initBulk () {
        this.checked = false;
        this.userIds = [];
        this.updateShowAddButton();
    }

    toggleAll () {
        this.userIds = this.checked ? this.list.items
            .filter((user) => !this.hasStartedApg(user))
            .map((user) => user.id) : [];
        this.updateShowAddButton();
    }

    toggleUserId (id) {
        if (this.hasUserId(id)) {
            this.lodash.pull(this.userIds, id);
            this.checked = false;
        }
        else {
            this.userIds.push(id);
        }

        this.updateShowAddButton();
    }

    hasUserId (id) {
        return this.lodash.includes(this.userIds, id);
    }

    updateShowAddButton () {
        this.showAddButton = this.userIds.length > 0;
        if (!this.showAddButton) {
            this.showNavigationError = false;
        }
    }

    showCheckbox (item) {
        return !this.hasStartedApg(item);
    }

    hasCourseApg (item) {
        return item.planningGroupsUser.length > 0;
    }

    hasStartedApg (item) {
        if (!item.planningGroupsUser.length > 0) {
            return false;
        }

        return !!item.planningGroupsUser
            .find((planningGroupUser) => planningGroupUser.automatedPlanningGroup.status
                === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STARTED);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/occurrence/automated/planningGroup/employee/table/index.js